import React from 'react';
import { BluescreenPromptedOne } from '../../components/BluescreenPromptedOne/BluescreenPromptedOne.component';
import userManager from '../../services/users/identity/user.service';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const LoggedOut: React.FC = () => {
  const handleOnClick = async () => {
    localStorage.clear();
    await userManager.signinRedirect({
      prompt: 'login',
    });
  };

  const { failed2FA } = useParams() as {
    failed2FA: string;
  };

  const { t } = useTranslation();

  useDocumentTitle('Nastąpiło wylogowanie z systemu');

  const is2faFailed = localStorage.getItem('2FA') === 'failed' || failed2FA === 'True'

  return (
    <BluescreenPromptedOne
      type="login"
      open={true}
      isBold={true}
      size="sm"
      mainText={
        is2faFailed
          ? `Nieudana próba autoryzacji. Twoje konto zostało czasowo zablokowane. Wróć za 15 minut na stronę główną i spróbuj zalogować się ponownie`
          : `Nastąpiło wylogowanie z systemu ${t('global:shortNames.system')}`
      }
      mainActionButtonText={
        is2faFailed ? 'Przejdź do strony głównej' : `Zaloguj się do ${t('global:shortNames.system')}`
      }
      onConfirm={handleOnClick}
      isRemovedBackdrop={true}
    />
  );
};
